var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnubesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 36,
    viewBox: "0 0 162 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "49jvubh07a",
    x1: "2.305%",
    x2: "100%",
    y1: "20.798%",
    y2: "77.026%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#50A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0746EB"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#49jvubh07a)",
    d: "M54.78 17c1.509 6.304-3.195 12.514-9.71 12.796-1.155.05-2.314.022-3.471.023-7.402.001-14.804.02-22.205-.02-1.157-.006-2.087.298-2.993.998-2.187 1.69-4.428 3.312-6.65 4.959-.275.204-1.25.431.088-1.585 1.1-2.055 2.828-4.382.834-4.36-1.536-.002-2.993-.128-4.452-.837-4.192-2.036-6.636-6.187-6.163-10.83.247-2.428 1.622-4.926 3.564-6.803.273-.251 2.385-2.117 5.686-2.858 3.506-.787 8.355-.296 13.121 3.294 0 0-.94-2.915-6.273-4.774 5.295-8.026 16.493-8.66 23.064-1.218.71.805 1.283 1.743 1.84 2.666.336.558.644.735 1.339.61 5.775-1.038 11.048 2.366 12.381 7.938zm-2.06 3.348c.32 0 .595-.24.629-.563.383-3.657-1.553-7.897-6.708-8.57-.345-.043-.663.198-.709.541-.045.344.198.66.544.704 4.341.566 5.949 4.021 5.616 7.195-.036.345.216.653.563.689.022.002.044.004.066.004z",
    transform: "translate(-405 -17) translate(405 17)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnubesLogo);
export default __webpack_public_path__ + "static/media/snubes-logo.7f6b245fa54eb342d38ef4a361023766.svg";
export { ForwardRef as ReactComponent };